export enum CORRESPONDANCE_EMAIL_CATEGORIES {
    CONTRACTED_SUPPLIER="Contracted Supplier",
    EXECUTOR_SUPPLIER="Executor Supplier",
    INSURERS="Policy Insurers",
    INSUREE="Insuree",
    LOCATIONS="Locations",
    REHOSPITALISATION="Rehospitalisation",
    TRAVELLER="Traveller",
    INSUREE_CONTACT_LIST="Insuree Contact List",
    INTERNAL_SOS="SOS Internal",
}
